class CarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = $(this);
    var autoplay = $(this).data('autoplay');
    var autoplay_speed = $(this).data('autospeed') * 1000;
    var animation_speed = $(this).data('anispeed');

    this.make_slider ($(this), autoplay, autoplay_speed, animation_speed);
  }

  make_slider(carousel, autoplay, autoplay_speed, animation_speed) {
    carousel.slick({
      dots: true,
      arrows: true,
      infinite: true,

      autoplay: autoplay, 
      autoplaySpeed: autoplay_speed,
      speed: animation_speed,
      pauseOnHover: false,
      pauseOnFocus: false,
      vertical: false,

      draggable: true,
      cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      infinite: true,
      useCSS: 1,
      initialSlide: 0,
      className: 'slick-slider-fade',
      touchThreshold: 100,

      centerMode: false,
      variableWidth: false,

      slidesToShow: 1,
      //fade: true,

      responsive: [
        {breakpoint: 1024,
         settings: {
         //slidesToShow: 3,
         //slidesToScroll: 1
         }
        },{
          breakpoint: 992,
          settings: {
          }
        }, {
          breakpoint: 768,
          settings: {
          }
        }, {
          breakpoint: 480,
          settings: {
          }
        }]
    });
  }
}

$('carousel-component').on('init', function (event, slick, direction) {
  if (!($('carousel-component .slick-slide').length > 1)) {
    $('carousel-component .slick-dots').hide();
  }
});

customElements.define('carousel-component', CarouselComponent);
